<template>
  <v-sheet outlined :class="{'btn-active':active}" elevation="2" @click.stop="goTo()" style="border-radius:50%" v-ripple
           :width="width" :height="height">
    <v-row class="fill-height" align="center" justify="center">
      <v-col class="text-center">
        <v-icon v-if="icon" :color="color" large>{{ icon }}</v-icon>
        <br v-if="text">
        <span v-if="text"
              style="word-break: break-word; font-size: 13px; font-weight: bold; display:block; line-height: 15px;"> {{
            text
          }} </span>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "BigRoundButton",
  props: {
    height: {type: String, default: '100'},
    width: {type: String, default: '100'},
    href: {type: String, default: null, required: false},
    to: {type: String, default: null, required: false},
    color: {type: String, default: null, required: false},
    icon: {type: String, default: null, required: false},
    text: {type: String, default: null, required: false}
  },
  computed: {
    active() {
      return this.$route.path === this.to
    }
  },
  methods: {
    goTo() {
      this.$emit('click')
      if (this.to) {
        this.$router.push(this.to)
      }
      if (this.href) {
        let a = document.createElement('a');
        a.href = this.href;
        a.click();
      }
    }
  }
}
</script>

<style scoped>
.btn-active {
  border: 2px blue solid;
}

</style>
